export const countries = [
  {
    name: "AFGHANISTAN",
    code: "res_naziones(52d755dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "ÅLAND ISLANDS",
    code: "res_naziones(722e32ee-10aa-e911-a975-000d3a3a019b)",
  },
  {
    name: "ALBANIA",
    code: "res_naziones(58d755dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "ALGERIA",
    code: "res_naziones(5ad755dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "AMERICAN SAMOA",
    code: "res_naziones(5cd755dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "ANDORRA",
    code: "res_naziones(5ed755dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "ANGOLA",
    code: "res_naziones(60d755dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "ANGUILLA",
    code: "res_naziones(62d755dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "ANTARCTICA",
    code: "res_naziones(64d755dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "ANTIGUA AND BARBUDA",
    code: "res_naziones(66d755dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "ARGENTINA",
    code: "res_naziones(6ad755dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "ARMENIA",
    code: "res_naziones(6cd755dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "ARUBA",
    code: "res_naziones(6ed755dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "AUSTRALIA",
    code: "res_naziones(72d755dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "AUSTRIA",
    code: "res_naziones(74d755dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "AZERBAIJAN",
    code: "res_naziones(76d755dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "BAHAMAS",
    code: "res_naziones(7ad755dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "BAHRAIN",
    code: "res_naziones(7cd755dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "BANGLADESH",
    code: "res_naziones(7ed755dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "BARBADOS",
    code: "res_naziones(80d755dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "BELARUS",
    code: "res_naziones(8cd755dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "BELGIUM",
    code: "res_naziones(82d755dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "BELIZE",
    code: "res_naziones(84d755dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "BENIN",
    code: "res_naziones(86d755dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "BERMUDA",
    code: "res_naziones(88d755dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "BHUTAN",
    code: "res_naziones(8ad755dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "BOLIVIA",
    code: "res_naziones(8ed755dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "BONAIRE, SINT EUSTATIUS AND SABA",
    code: "res_naziones(90d755dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "BOSNIA AND HERZEGOVINA",
    code: "res_naziones(92d755dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "BOTSWANA",
    code: "res_naziones(94d755dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "BOUVET ISLAND",
    code: "res_naziones(96d755dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "BRAZIL",
    code: "res_naziones(98d755dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "BRITISH INDIAN OCEAN TERRITORY (THE)",
    code: "res_naziones(38d955dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "BRITISH VIRGIN ISLANDS",
    code: "res_naziones(64d955dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "BRUNEI DARUSSALAM",
    code: "res_naziones(9ad755dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "BULGARIA",
    code: "res_naziones(9cd755dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "BURKINA FASO",
    code: "res_naziones(9ed755dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "BURUNDI",
    code: "res_naziones(a0d755dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "CAMBODIA",
    code: "res_naziones(a2d755dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "CAMEROON",
    code: "res_naziones(a4d755dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "CANADA",
    code: "res_naziones(a8d755dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "CAPE VERDE",
    code: "res_naziones(acd755dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "CAYMAN ISLANDS (THE)",
    code: "res_naziones(b0d755dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "CENTRAL AFRICAN REPUBLIC (THE)",
    code: "res_naziones(b4d755dc-0572-e711-810b-e0071b6e07f1)",
  },
  { name: "CHAD", code: "res_naziones(bed755dc-0572-e711-810b-e0071b6e07f1)" },
  {
    name: "CHILE",
    code: "res_naziones(c0d755dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "CHINA",
    code: "res_naziones(c2d755dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "CHRISTMAS ISLAND",
    code: "res_naziones(bcd755dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "COCOS (KEELING) ISLANDS (THE)",
    code: "res_naziones(c8d755dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "COLOMBIA",
    code: "res_naziones(cad755dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "COMOROS (THE)",
    code: "res_naziones(ccd755dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "CONGO",
    code: "res_naziones(ced755dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "CONGO (THE DEMOCRATIC REPUBLIC OF THE)",
    code: "res_naziones(d0d755dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "COOK ISLANDS (THE)",
    code: "res_naziones(d2d755dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "COSTA RICA",
    code: "res_naziones(dad755dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "CÔTE D'IVOIRE",
    code: "res_naziones(d8d755dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "CROATIA",
    code: "res_naziones(dcd755dc-0572-e711-810b-e0071b6e07f1)",
  },
  { name: "CUBA", code: "res_naziones(ded755dc-0572-e711-810b-e0071b6e07f1)" },
  {
    name: "CURAÇAO",
    code: "res_naziones(e0d755dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "CYPRUS",
    code: "res_naziones(c4d755dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "CZECHIA",
    code: "res_naziones(b2d755dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "DENMARK",
    code: "res_naziones(e2d755dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "DJIBOUTI",
    code: "res_naziones(14d855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "DOMINICA",
    code: "res_naziones(e4d755dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "DOMINICAN REPUBLIC (THE)",
    code: "res_naziones(e6d755dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "ECUADOR",
    code: "res_naziones(ead755dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "EGYPT",
    code: "res_naziones(ecd755dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "EL SALVADOR",
    code: "res_naziones(eed755dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "EQUATORIAL GUINEA",
    code: "res_naziones(2ed855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "ERITREA",
    code: "res_naziones(f0d755dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "ESTONIA",
    code: "res_naziones(f2d755dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "ESWATINI",
    code: "res_naziones(2ed955dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "ETHIOPIA",
    code: "res_naziones(f4d755dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "FALKLAND ISLANDS (THE) [MALVINAS]",
    code: "res_naziones(f8d755dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "FAROE ISLANDS (THE)",
    code: "res_naziones(f6d755dc-0572-e711-810b-e0071b6e07f1)",
  },
  { name: "FIJI", code: "res_naziones(fad755dc-0572-e711-810b-e0071b6e07f1)" },
  {
    name: "FINLAND",
    code: "res_naziones(fed755dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "FRANCE",
    code: "res_naziones(00d855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "FRENCH GUIANA",
    code: "res_naziones(28d855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "FRENCH POLYNESIA",
    code: "res_naziones(d0d855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "FRENCH SOUTHERN TERRITORIES (THE)",
    code: "res_naziones(36d955dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "GABON",
    code: "res_naziones(04d855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "GAMBIA",
    code: "res_naziones(06d855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "GEORGIA",
    code: "res_naziones(08d855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "GERMANY",
    code: "res_naziones(0ad855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "GHANA",
    code: "res_naziones(0cd855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "GIBRALTAR",
    code: "res_naziones(12d855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "GREECE",
    code: "res_naziones(1ad855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "GREENLAND",
    code: "res_naziones(1ed855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "GRENADA",
    code: "res_naziones(1cd855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "GUADELOUPE",
    code: "res_naziones(20d855dc-0572-e711-810b-e0071b6e07f1)",
  },
  { name: "GUAM", code: "res_naziones(22d855dc-0572-e711-810b-e0071b6e07f1)" },
  {
    name: "GUATEMALA",
    code: "res_naziones(24d855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "GUERNSEY",
    code: "res_naziones(26d855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "GUINEA",
    code: "res_naziones(2ad855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "GUINEA-BISSAU",
    code: "res_naziones(2cd855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "GUYANA",
    code: "res_naziones(30d855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "HAITI",
    code: "res_naziones(32d855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "HEARD ISLAND AND MCDONALD ISLANDS",
    code: "res_naziones(34d855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "HOLY SEE (THE)",
    code: "res_naziones(f8d855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "HONDURAS",
    code: "res_naziones(36d855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "HONG KONG",
    code: "res_naziones(38d855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "HUNGARY",
    code: "res_naziones(58d955dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "ICELAND",
    code: "res_naziones(44d855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "INDIA",
    code: "res_naziones(3ad855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "INDONESIA",
    code: "res_naziones(3cd855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "IRAN (ISLAMIC REPUBLIC OF)",
    code: "res_naziones(3ed855dc-0572-e711-810b-e0071b6e07f1)",
  },
  { name: "IRAQ", code: "res_naziones(40d855dc-0572-e711-810b-e0071b6e07f1)" },
  {
    name: "IRELAND",
    code: "res_naziones(42d855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "ISLE OF MAN",
    code: "res_naziones(7ed855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "ISRAEL",
    code: "res_naziones(48d855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "ITALY",
    code: "res_naziones(4ad855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "JAMAICA",
    code: "res_naziones(0ed855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "JAPAN",
    code: "res_naziones(10d855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "JERSEY",
    code: "res_naziones(4cd855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "JORDAN",
    code: "res_naziones(16d855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "KAZAKHSTAN",
    code: "res_naziones(4ed855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "KENYA",
    code: "res_naziones(50d855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "KIRIBATI",
    code: "res_naziones(52d855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "KOREA (THE DEMOCRATIC PEOPLE'S REPUBLIC OF)",
    code: "res_naziones(d4d755dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "KOREA (THE REPUBLIC OF)",
    code: "res_naziones(d6d755dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "KOSOVO",
    code: "res_naziones(54d855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "KUWAIT",
    code: "res_naziones(56d855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "KYRGYZSTAN",
    code: "res_naziones(58d855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "LAO PEOPLE'S DEMOCRATIC REPUBLIC (THE)",
    code: "res_naziones(5ad855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "LATVIA",
    code: "res_naziones(5ed855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "LEBANON",
    code: "res_naziones(60d855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "LESOTHO",
    code: "res_naziones(5cd855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "LIBERIA",
    code: "res_naziones(62d855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "LIBYA",
    code: "res_naziones(64d855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "LIECHTENSTEIN",
    code: "res_naziones(66d855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "LITHUANIA",
    code: "res_naziones(68d855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "LUXEMBOURG",
    code: "res_naziones(6ad855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "MACAO",
    code: "res_naziones(6cd855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "MACEDONIA (THE FORMER YUGOSLAV REPUBLIC OF)",
    code: "res_naziones(6ed855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "MADAGASCAR",
    code: "res_naziones(70d855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "MALAWI",
    code: "res_naziones(74d855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "MALAYSIA",
    code: "res_naziones(76d855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "MALDIVES",
    code: "res_naziones(78d855dc-0572-e711-810b-e0071b6e07f1)",
  },
  { name: "MALI", code: "res_naziones(7ad855dc-0572-e711-810b-e0071b6e07f1)" },
  {
    name: "MALTA",
    code: "res_naziones(7cd855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "MARSHALL ISLANDS (THE)",
    code: "res_naziones(84d855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "MARTINIQUE",
    code: "res_naziones(86d855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "MAURITANIA",
    code: "res_naziones(88d855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "MAURITIUS",
    code: "res_naziones(8ad855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "MAYOTTE",
    code: "res_naziones(8cd855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "MEXICO",
    code: "res_naziones(90d855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "MICRONESIA (FEDERATED STATES OF)",
    code: "res_naziones(92d855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "MOLDOVA (THE REPUBLIC OF)",
    code: "res_naziones(96d855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "MONACO",
    code: "res_naziones(d8d855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "MONGOLIA",
    code: "res_naziones(98d855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "MONTENEGRO",
    code: "res_naziones(9ad855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "MONTSERRAT",
    code: "res_naziones(9cd855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "MOROCCO",
    code: "res_naziones(82d855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "MOZAMBIQUE",
    code: "res_naziones(9ed855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "MYANMAR",
    code: "res_naziones(a0d855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "NAMIBIA",
    code: "res_naziones(a2d855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "NAURU",
    code: "res_naziones(a4d855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "NEPAL",
    code: "res_naziones(a6d855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "NETHERLANDS",
    code: "res_naziones(bad855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "NEW CALEDONIA",
    code: "res_naziones(b4d855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "NEW ZEALAND",
    code: "res_naziones(b6d855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "NICARAGUA",
    code: "res_naziones(a8d855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "NIGER",
    code: "res_naziones(aad855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "NIGERIA",
    code: "res_naziones(acd855dc-0572-e711-810b-e0071b6e07f1)",
  },
  { name: "NIUE", code: "res_naziones(aed855dc-0572-e711-810b-e0071b6e07f1)" },
  {
    name: "NORFOLK ISLAND",
    code: "res_naziones(b0d855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "NORTHERN MARIANA ISLANDS (THE)",
    code: "res_naziones(80d855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "NORWAY",
    code: "res_naziones(b2d855dc-0572-e711-810b-e0071b6e07f1)",
  },
  { name: "OMAN", code: "res_naziones(b8d855dc-0572-e711-810b-e0071b6e07f1)" },
  {
    name: "PAKISTAN",
    code: "res_naziones(bcd855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "PALAU",
    code: "res_naziones(bed855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "PALESTINE, STATE OF",
    code: "res_naziones(c0d855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "PANAMA",
    code: "res_naziones(c2d855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "PAPUA NEW GUINEA",
    code: "res_naziones(c4d855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "PARAGUAY",
    code: "res_naziones(c6d855dc-0572-e711-810b-e0071b6e07f1)",
  },
  { name: "PERU", code: "res_naziones(ccd855dc-0572-e711-810b-e0071b6e07f1)" },
  {
    name: "PHILIPPINES",
    code: "res_naziones(fcd755dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "PITCAIRN",
    code: "res_naziones(ced855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "POLAND",
    code: "res_naziones(d2d855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "PORTUGAL",
    code: "res_naziones(d4d855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "PUERTO RICO",
    code: "res_naziones(d6d855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "QATAR",
    code: "res_naziones(dad855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "RÉUNION",
    code: "res_naziones(e0d855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "ROMANIA",
    code: "res_naziones(e2d855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "RUSSIAN FEDERATION (THE)",
    code: "res_naziones(e4d855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "RWANDA",
    code: "res_naziones(e6d855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "SAINT BARTHÉLEMY",
    code: "res_naziones(ead855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "SAINT HELENA",
    code: "res_naziones(762e32ee-10aa-e911-a975-000d3a3a019b)",
  },
  {
    name: "SAINT KITTS AND NEVIS",
    code: "res_naziones(1cd955dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "SAINT LUCIA",
    code: "res_naziones(f6d855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "SAINT MARTIN (FRENCH PART)",
    code: "res_naziones(ecd855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "SAINT PIERRE AND MIQUELON",
    code: "res_naziones(eed855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "SAINT VINCENT AND THE GRENADINES",
    code: "res_naziones(18d955dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "SAMOA",
    code: "res_naziones(f2d855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "SAN MARINO",
    code: "res_naziones(f4d855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "SAO TOME AND PRINCIPE",
    code: "res_naziones(fcd855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "SAUDI ARABIA",
    code: "res_naziones(68d755dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "SENEGAL",
    code: "res_naziones(fed855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "SERBIA",
    code: "res_naziones(00d955dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "SEYCHELLES",
    code: "res_naziones(02d955dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "SIERRA LEONE",
    code: "res_naziones(06d955dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "SINGAPORE",
    code: "res_naziones(08d955dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "SINT MAARTEN (DUTCH PART)",
    code: "res_naziones(0ad955dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "SLOVAKIA",
    code: "res_naziones(0ed955dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "SLOVENIA",
    code: "res_naziones(10d955dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "SOLOMON ISLANDS",
    code: "res_naziones(f0d855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "SOMALIA",
    code: "res_naziones(12d955dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "SOUTH AFRICA",
    code: "res_naziones(22d955dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS",
    code: "res_naziones(1ed955dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "SOUTH SUDAN",
    code: "res_naziones(20d955dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "SPAIN",
    code: "res_naziones(14d955dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "SRI LANKA",
    code: "res_naziones(16d955dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "SUDAN",
    code: "res_naziones(24d955dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "SURINAME",
    code: "res_naziones(26d955dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "SVALBARD AND JAN MAYEN",
    code: "res_naziones(28d955dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "SWEDEN",
    code: "res_naziones(2ad955dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "SWITZERLAND",
    code: "res_naziones(2cd955dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "SYRIA",
    code: "res_naziones(0cd955dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "TAIWAN",
    code: "res_naziones(32d955dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "TAJIKISTAN",
    code: "res_naziones(30d955dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "TANZANIA, UNITED REPUBLIC OF",
    code: "res_naziones(34d955dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "THAILAND",
    code: "res_naziones(3ad955dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "TIMOR-LESTE",
    code: "res_naziones(3cd955dc-0572-e711-810b-e0071b6e07f1)",
  },
  { name: "TOGO", code: "res_naziones(3ed955dc-0572-e711-810b-e0071b6e07f1)" },
  {
    name: "TOKELAU",
    code: "res_naziones(40d955dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "TONGA",
    code: "res_naziones(42d955dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "TRINIDAD AND TOBAGO",
    code: "res_naziones(44d955dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "TUNISIA",
    code: "res_naziones(48d955dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "TURKEY",
    code: "res_naziones(4ad955dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "TURKMENISTAN",
    code: "res_naziones(4cd955dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "TURKS AND CAICOS ISLANDS (THE)",
    code: "res_naziones(4ed955dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "TUVALU",
    code: "res_naziones(50d955dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "UGANDA",
    code: "res_naziones(54d955dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "UKRAINE",
    code: "res_naziones(52d955dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "UNITED ARAB EMIRATES",
    code: "res_naziones(bb9330fc-7177-e711-8112-e0071b6e3471)",
  },
  {
    name: "UNITED KINGDOM",
    code: "res_naziones(ded855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "UNITED STATES MINOR OUTLYING ISLANDS (THE)",
    code: "res_naziones(742e32ee-10aa-e911-a975-000d3a3a019b)",
  },
  {
    name: "UNITED STATES OF AMERICA (THE)",
    code: "res_naziones(1ad955dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "URUGUAY",
    code: "res_naziones(5ad955dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "UZBEKISTAN",
    code: "res_naziones(5cd955dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "VANUATU",
    code: "res_naziones(5ed955dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "VENEZUELA",
    code: "res_naziones(60d955dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "VIETNAM",
    code: "res_naziones(66d955dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "VIRGIN ISLANDS, US",
    code: "res_naziones(62d955dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "WALLIS AND FUTUNA ISLANDS",
    code: "res_naziones(6ad955dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "WESTERN SAHARA",
    code: "res_naziones(e8d855dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "YEMEN",
    code: "res_naziones(6cd955dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "ZAMBIA",
    code: "res_naziones(6ed955dc-0572-e711-810b-e0071b6e07f1)",
  },
  {
    name: "ZIMBABWE",
    code: "res_naziones(70d955dc-0572-e711-810b-e0071b6e07f1)",
  },
];
